import { defineComponent as A, openBlock as t, createElementBlock as a, mergeProps as d, unref as o, renderSlot as i, createElementVNode as e, createCommentVNode as p } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const V = { key: 0 }, M = { key: 1 }, g = { key: 2 }, v = { key: 3 }, f = { key: 4 }, k = { key: 5 }, w = {
  name: "ScalarIconFastForwardCircle"
}, _ = /* @__PURE__ */ A({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const Z = r, { bind: m, weight: n } = u(Z);
    return (s, l) => (t(), a("svg", d({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(m)), [
      i(s.$slots, "default"),
      o(n) === "bold" ? (t(), a("g", V, l[0] || (l[0] = [
        e("path", { d: "M196,128a12,12,0,0,1-4.5,9.37l-40,32A12,12,0,0,1,132,160V140.17l-36.5,29.2A12,12,0,0,1,76,160V96a12,12,0,0,1,19.5-9.37l36.5,29.2V96a12,12,0,0,1,19.5-9.37l40,32A12,12,0,0,1,196,128Zm40,0A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (t(), a("g", M, l[1] || (l[1] = [
        e("path", {
          d: "M128,32a96,96,0,1,0,96,96A96,96,0,0,0,128,32ZM80,164V92l48,36Zm64,0V92l48,36Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm68.8-94.4-48-36A8,8,0,0,0,136,92v72a8,8,0,0,0,12.8,6.4l48-36a8,8,0,0,0,0-12.8ZM152,148V108l26.67,20Zm-19.2-26.4-48-36A8,8,0,0,0,72,92v72a8,8,0,0,0,12.8,6.4l48-36a8,8,0,0,0,0-12.8ZM88,148V108l26.67,20Z" }, null, -1)
      ]))) : o(n) === "fill" ? (t(), a("g", g, l[2] || (l[2] = [
        e("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm68.8,110.4-48,36A8,8,0,0,1,144,172a8,8,0,0,1-8-8V128a8,8,0,0,1-3.2,6.4l-48,36A8,8,0,0,1,80,172a8,8,0,0,1-8-8V92a8,8,0,0,1,12.8-6.4l48,36A8,8,0,0,1,136,128V92a8,8,0,0,1,12.8-6.4l48,36a8,8,0,0,1,0,12.8Z" }, null, -1)
      ]))) : o(n) === "light" ? (t(), a("g", v, l[3] || (l[3] = [
        e("path", { d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Zm63.6-94.8-48-36A6,6,0,0,0,134,92v30L87.6,87.2A6,6,0,0,0,78,92v72a6,6,0,0,0,9.6,4.8L134,134v30a6,6,0,0,0,9.6,4.8l48-36a6,6,0,0,0,0-9.6ZM90,152V104l32,24Zm56,0V104l32,24Z" }, null, -1)
      ]))) : o(n) === "regular" ? (t(), a("g", f, l[4] || (l[4] = [
        e("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm68.8-94.4-48-36A8,8,0,0,0,136,92v72a8,8,0,0,0,12.8,6.4l48-36a8,8,0,0,0,0-12.8ZM152,148V108l26.67,20Zm-19.2-26.4-48-36A8,8,0,0,0,72,92v72a8,8,0,0,0,12.8,6.4l48-36a8,8,0,0,0,0-12.8ZM88,148V108l26.67,20Z" }, null, -1)
      ]))) : o(n) === "thin" ? (t(), a("g", k, l[5] || (l[5] = [
        e("path", { d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm62.4-95.2-48-36A4,4,0,0,0,136,92v72a4,4,0,0,0,2.21,3.58A4.05,4.05,0,0,0,140,168a4,4,0,0,0,2.4-.8l48-36a4,4,0,0,0,0-6.4ZM144,156V100l37.33,28Zm-9.6-31.2-48-36A4,4,0,0,0,80,92v72a4,4,0,0,0,2.21,3.58A4.05,4.05,0,0,0,84,168a4,4,0,0,0,2.4-.8l48-36a4,4,0,0,0,0-6.4ZM88,156V100l37.33,28Z" }, null, -1)
      ]))) : p("", !0)
    ], 16));
  }
});
export {
  _ as default
};
